<script setup lang="ts">
import { ref, type Ref, computed, inject } from 'vue'
import { default as PTag } from 'primevue/tag'
import { EvaluationRange } from '@/core/domain/resources/enums/EvaluationRange.ts'
import { default as PPopover } from 'primevue/popover'

// Use provide/inject pattern to avoid recreating auth store for each component
const authInfo = inject<{ isAdmin: boolean; isEduEngineer: boolean }>('authInfo', {
  isAdmin: false,
  isEduEngineer: false
})

const props = defineProps<{
  evalRange?: EvaluationRange.Values | null
  score?: number | null
  progress?: '+' | '-' | '='
  quizVersionNumber?: number | null
}>()

const tooltip: Ref<any | null> = ref(null)

// Optimize popover logic - only show if has version number and user has permissions
const shouldShowPopover = computed(() => {
  return props.quizVersionNumber && (authInfo.isAdmin || authInfo.isEduEngineer)
})

const togglePopover = (event: Event) => {
  if (shouldShowPopover.value && tooltip.value) {
    tooltip.value.toggle(event)
  }
}
</script>

<template>
  <div
    class="flex items-center gap-2"
    @mouseenter="shouldShowPopover ? (e) => togglePopover(e) : undefined"
    @mouseleave="shouldShowPopover ? (e) => togglePopover(e) : undefined"
  >
    <template v-if="evalRange">
      <p class="text small w-10 font-bold">{{ score }}%</p>
      <p-tag
        class="font-secondary font-medium"
        :class="{
          'bg-green-300 text-green-900': evalRange === EvaluationRange.Values.FORCE,
          'bg-yellow-300 text-yellow-900': evalRange === EvaluationRange.Values.EFFORT_A_FAIRE,
          'bg-red-300 text-red-900': evalRange === EvaluationRange.Values.DEFI
        }"
      >
        <i
          v-if="progress"
          class="pi mr-1"
          :class="{
            'pi-arrow-up rotate-45': progress === '+',
            'pi-arrow-down rotate-45': progress === '-',
            'pi-equals': progress === '='
          }"
        />

        {{ EvaluationRange.label(evalRange) }}
      </p-tag>
      <p-popover v-if="shouldShowPopover" ref="tooltip">
        <p class="text small">- Version du quiz : {{ quizVersionNumber }}</p>
      </p-popover>
    </template>

    <template v-else>
      <p class="text small font-bold">-</p>
    </template>
  </div>
</template>
